/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: 'IT-Header-USP-eSpot_rv' },
    { emsName: 'HeaderStoreLogo'},
    { emsName: 'IT-Header-Klantenservice-Link-eSpot_rv'},
    { emsName: 'IT-Header-HelloRetail-Popular-Products-Heading' }
];
export default contentItems;
